"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _member = require("@/api/member/member");
var _RegistrationLevel = require("@/api/hierarchicalCommissionAllocation/RegistrationLevel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RegistrationLevel',
  data: function data() {
    return {
      options: [],
      ruleForm: {
        grade: null
      },
      rules: {
        // grade: [
        //   { required: true, message: '用户注册时成为的等级（默认选择初始等级）', trigger: 'change' }
        // ]
      },
      selectedGradeName: ''
    };
  },
  mounted: function mounted() {
    this.memberQueryMemberGradeApi();
    this.queryRegisterGrade();
  },
  methods: {
    onGradeChange: function onGradeChange(val) {
      var selected = this.options.find(function (item) {
        return item.grade === val;
      });
      if (selected) {
        this.selectedGradeName = selected.name;
      }
    },
    // 列表
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    queryRegisterGrade: function () {
      var _queryRegisterGrade2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _RegistrationLevel.queryRegisterGrade)();
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.ruleForm.grade = res.data.registerGrade;
                this.selectedGradeName = res.data.registerGradeName;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function queryRegisterGrade() {
        return _queryRegisterGrade2.apply(this, arguments);
      }
      return queryRegisterGrade;
    }(),
    editRegisterGrade: function () {
      var _editRegisterGrade2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                registerGrade: this.ruleForm.grade
              };
              _context3.n = 1;
              return (0, _RegistrationLevel.editRegisterGrade)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.queryRegisterGrade();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function editRegisterGrade() {
        return _editRegisterGrade2.apply(this, arguments);
      }
      return editRegisterGrade;
    }(),
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm("\u786E\u8BA4\u8BBE\u7F6E\u3010".concat(_this.selectedGradeName, "\u3011\u4E3A\u7528\u6237\u6CE8\u518C\u7B49\u7EA7?"), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.editRegisterGrade();
          });
        } else {
          return false;
        }
      });
    }
  }
};